var _path, _polygon, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "64.275px",
    height: "64.55px",
    viewBox: "0 0 64.275 64.55",
    enableBackground: "new 0 0 64.275 64.55",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 6.8643,
    y1: 62.7661,
    x2: 1.85,
    y2: 40.1633
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#C80F00"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#640000"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M7.334,45.784c0.941-0.082,1.71,0.625,1.71,1.569v16.308c0,0.943-0.55,1.174-1.223,0.512   l-6.987-5.301c-0.672-0.663-0.762-0.873-0.762-1.817v-8.929c0-0.944,0.77-1.783,1.71-1.864L7.334,45.784z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#FF0000",
    points: "0.057,57.575 57.632,0 31.649,0 0,31.649  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M13.341,22.835c-0.079-0.079-0.206-0.078-0.285,0l-1.298,1.307c-0.038,0.038-0.059,0.089-0.059,0.143    s0.021,0.104,0.06,0.142l4.343,4.315l-5.757-2.977c-0.078-0.041-0.173-0.026-0.235,0.037l-1.532,1.542    C8.5,27.421,8.501,27.549,8.58,27.627l8.709,8.654c0.039,0.038,0.09,0.058,0.142,0.058c0.051,0,0.103-0.02,0.143-0.06l1.298-1.307    c0.037-0.037,0.059-0.088,0.059-0.142s-0.021-0.104-0.06-0.143l-4.927-4.896l6.522,3.375c0.079,0.041,0.174,0.026,0.235-0.037    l1.35-1.359c0.079-0.078,0.078-0.206,0-0.284L13.341,22.835z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.051,25.025c-0.037-0.038-0.088-0.058-0.142-0.058s-0.104,0.021-0.143,0.06l-2.35,2.365l-2.303-2.288    l1.87-1.882c0.079-0.079,0.079-0.206,0-0.284l-1.219-1.212c-0.038-0.038-0.09-0.058-0.143-0.058c-0.053,0-0.104,0.021-0.142,0.059    l-1.87,1.882l-2.179-2.164l2.351-2.366c0.079-0.079,0.078-0.206-0.001-0.285l-1.219-1.212c-0.038-0.037-0.09-0.057-0.143-0.058    c-0.053,0-0.104,0.022-0.142,0.06l-3.869,3.893c-0.078,0.078-0.077,0.206,0.001,0.284l8.709,8.653    c0.04,0.04,0.09,0.059,0.142,0.059s0.103-0.02,0.143-0.059l3.868-3.893c0.078-0.079,0.077-0.206-0.001-0.284L26.051,25.025z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M26.502,9.637c-0.035-0.047-0.089-0.077-0.147-0.082c-0.059-0.004-0.117,0.017-0.158,0.059l-1.376,1.385    c-0.071,0.071-0.078,0.184-0.018,0.263l4.173,5.474l-5.489-4.149c-0.08-0.061-0.192-0.053-0.264,0.018l-1.22,1.229    c-0.071,0.071-0.079,0.184-0.017,0.264l4.184,5.462l-5.5-4.138c-0.081-0.061-0.193-0.052-0.264,0.019l-1.415,1.424    c-0.042,0.042-0.063,0.1-0.058,0.159c0.005,0.059,0.035,0.112,0.083,0.146l10.111,7.243c0.035,0.025,0.076,0.037,0.117,0.037    c0.052,0,0.104-0.02,0.143-0.059l1.402-1.411c0.07-0.07,0.078-0.182,0.019-0.262l-3.685-4.988l5,3.664    c0.08,0.059,0.192,0.05,0.262-0.021l1.402-1.411c0.069-0.07,0.078-0.18,0.02-0.26L26.502,9.637z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M37.521,15.922l-1.395-1.385c-0.037-0.038-0.088-0.059-0.141-0.059h-0.002    c-0.053,0-0.104,0.021-0.142,0.06l-1.454,1.463c-0.078,0.079-0.078,0.206,0.001,0.285l1.394,1.384    c0.038,0.038,0.089,0.059,0.142,0.059h0.001c0.054,0,0.104-0.021,0.143-0.06l1.453-1.463C37.599,16.128,37.599,16,37.521,15.922z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M35.216,13.918l-6.389-6.66c-0.038-0.039-0.09-0.062-0.144-0.062c0,0-0.001,0-0.002,0    c-0.053,0-0.104,0.021-0.143,0.06L27.06,8.746C27.021,8.784,27,8.836,27.001,8.89c0.001,0.055,0.023,0.105,0.063,0.143    l6.701,6.346c0.038,0.037,0.088,0.055,0.138,0.055c0.052,0,0.104-0.02,0.143-0.059l1.168-1.176    C35.29,14.122,35.291,13.997,35.216,13.918z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewItem);
export default __webpack_public_path__ + "static/media/new-item.d771dd608bf6415fd7a20e59ed936110.svg";
export { ForwardRef as ReactComponent };